import {ConstProject} from "../const/project";
import {ProjectSystemType} from "../../model2/project/types";

export const ProjectSystemStatuses = [
    {
        id              : ConstProject.workfolderStatus.OPEN,
        systemStatus    : ConstProject.workfolderStatus.OPEN,
        name            : ConstProject.workfolderStatusList[2],
        color           : 5
    },
    {
        id              : ConstProject.workfolderStatus.CLOSED,
        systemStatus    : ConstProject.workfolderStatus.CLOSED,
        name            : ConstProject.workfolderStatusList[5],
        color           : 11
    },
]


export default class ProjectStatusManager {

    static getSystemStatusOptions() {

        return _.map(ProjectSystemStatuses, (status:any)=>{
            return {
                value:          status.id,
                // systemStatus:   status.systemStatus,
                label:          status.name,
                color:          status.color
            }
        })

    }


    static exportDefaultStatusesToOptions(systemType:any) {
        return ProjectStatusManager.getDefaultStatuses(systemType).map((s:any)=>({
            value:          s.systemStatus,
            systemStatus:   s.systemStatus,
            label:          s.name,
            color:          s.color
        }));
    }

    static getDefaultStatuses(systemType:any, options = {
        idOnly: false,
        exportToOptions: false
    }) {
        const { OPEN, CLOSED } = ConstProject.workfolderStatus;
        let res : any = [
            { id: OPEN,     systemStatus: OPEN,     name: ConstProject.workfolderStatusList[2],       color: 5 },
            { id: CLOSED,   systemStatus: CLOSED,   name: ConstProject.workfolderStatusList[5],     color: 11 },
        ];

        if (options.exportToOptions) {
            res = res.map((status:any)=>{
                return {
                    value:          status.id,
                    systemStatus:   status.systemStatus,
                    label:          status.name,
                    color:          status.color
                }
            });
        } else if (options.idOnly) {
            res = res.map((status:any)=>status.id);
        }

        return res;
    }

    static getProjectStatuses(id:string, options:any = {
        idOnly: false,
        exportToOptions: false
    }) {
        const project = gd.session.projects.get(id);

        let res = !!project && !!project.statuses ? project.statuses : [];

        if (res.length === 0) {
            if (project) {
                if (project.localTemplateId) {
                    const template = gd.session.templatesList.get(project.localTemplateId)

                    if (!template) {
                        console.error("No project template found - error #847503")
                    } else {
                        res = gd.session.templatesList.get(project.localTemplateId).statuses;
                    }
                }
            } else {
                console.warn("no project found in session #887fjsq");
            }
        }

        if (options.exportToOptions) {
            res = res.map((sId:any)=>{
                const status = gd.session.statuses.get(sId);
                return {
                    value:          status.id,
                    systemStatus:   status.systemStatus,
                    label:          status.name,
                    color:          status.color
                }
            });
        } else if (!options.idOnly) {
            res = res.map((sId:any)=>gd.session.statuses.get(sId));
        }

        return res;
    }

    static getProjectStatusValue(project:any) {
        let value = null;
        switch (project.systemType) {
            case ProjectSystemType.PROJECT:
            case ProjectSystemType.BACKLOG:
            case ProjectSystemType.SPRINT:
                value = project.statusId
                break

            case ProjectSystemType.TAG:
            case ProjectSystemType.WORKFOLDER:
            case ProjectSystemType.CATEGORY:
            case ProjectSystemType.PAGE:
            case ProjectSystemType.EMBED:
            case ProjectSystemType.VIEW:
                value = project.systemStatus
                break
        }

        return value;
    }

    static getProjectStatusOptions(project:any) {
        let options = [];
        switch (project.systemType) {
            case ProjectSystemType.PROJECT:
            case ProjectSystemType.BACKLOG:
            case ProjectSystemType.SPRINT:
                options = ProjectStatusManager.getProjectStatuses(project.id, {exportToOptions:true})
                break

            case ProjectSystemType.TAG:
            case ProjectSystemType.FOLDER:
            case ProjectSystemType.CATEGORY:
            case ProjectSystemType.PAGE:
            case ProjectSystemType.LINK:
            case ProjectSystemType.EMBED:
            case ProjectSystemType.VIEW:
                options = ProjectStatusManager.exportDefaultStatusesToOptions(project.systemType)
                break
        }

        return options;
    }

    static getProjectStatus(project:any) {
        const value = ProjectStatusManager.getProjectStatusValue(project);
        if (!value) return null;
        const options = ProjectStatusManager.getProjectStatusOptions(project);
        return _.find(options,  opt => opt.value === value);
    }
}